import Layout from '@/components/layout/index.vue'

export default {
  path: 'qualitycollaboration',
  name: 'Qualitycollaboration',
  meta: {},
  component: Layout,
  redirect: { name: 'Qualitycollaboration.Checkreturn' },
  children: [
    {
      path: 'checkreturn',
      name: 'Qualitycollaboration.Checkreturn',
      meta: {},
      component: () => import(/* webpackChunkName: "qualitycollaboration" */ '@/views/purchaser/qualitycollaboration/checkreturn/index.ts')
    },
    {
      path: 'returndetails',
      name: 'Qualitycollaboration.Returndetails',
      meta: {},
      component: () => import(/* webpackChunkName: "qualitycollaboration" */ '@/views/purchaser/qualitycollaboration/returndetails/index.ts')
    }
  ]
}
